import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import router from './router';
import VueTheMask from 'vue-the-mask';
import VueClipboard from 'vue-clipboard2';
import ColorInput from './components/ColorInput';
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';

Vue.config.productionTip = false;

Vue.use(VueTheMask);
Vue.use(VueClipboard);
Vue.component('ColorInput', ColorInput);

const stageHostName = 'stage.codenames.custit.de';

function resolveEnvironment() {
  if (
    process.env.NODE_ENV === 'production' &&
    window.location.host.startsWith(stageHostName)
  ) {
    return 'staging';
  }

  return process.env.NODE_ENV;
}

Sentry.init({
  dsn:
    'https://0d090b701c1b497bb97416356baa6f13@o229880.ingest.sentry.io/5203844',
  environment: resolveEnvironment(),
  integrations: [
    new VueIntegration({ Vue, attachProps: true, logErrors: true }),
  ],
  beforeSend(event) {
    // Check if it is an exception, and if so, show the report dialog
    if (event.exception && resolveEnvironment() !== 'development') {
      Sentry.showReportDialog({ eventId: event.event_id });
    }
    return event;
  },
});

new Vue({
  vuetify,
  router,
  render(h) {
    return h(App);
  },
}).$mount('#app');
